/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-08-19 10:03:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-07-07 14:33:14
 * @FilePath: \web_admin\src\service\api\forgot-password.js
 */
//二次验证
import http from "../httpConfig"
const table = "mrbase_sys_users"
// 
export const login_auth = (params = {}) => {
  params["~table~"] = 'mrbase_sys_company_auth'
  return new Promise((resolve, reject) => {
    http
      .post("/api/base/auth/login-auth/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

//获取验证码
export const get_code = (params = {}) => {
  params["~table~"] = 'mrbase_sys_company_auth'
  return new Promise((resolve, reject) => {
    http
      .post("/api/base/auth/send-auth/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
